/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { setLanguage, useLang } from '../../../../_metronic/i18n/Metronici18n'
import { toAbsoluteUrl } from '../../../../_metronic/helpers'

const Languages: FC = () => {
  const lang = useLang()
  const intl = useIntl()
  const languages = [
    {
      lang: 'en',
      name: intl.formatMessage({ id: 'PROFILE.SETTINGS.LENGUAGE.ENGLISH' }),
      flag: toAbsoluteUrl('/media/flags/united-states.svg'),
    },
    {
      lang: 'es',
      name: intl.formatMessage({ id: 'PROFILE.SETTINGS.LENGUAGE.SPANISH' }),
      flag: toAbsoluteUrl('/media/flags/spain.svg'),
    },
  ]
  const currentLanguage = languages.find((x) => x.lang === lang)
  return (
    <div className='d-flex flex-row justify-content-center py-4'>
      {languages.map((l) => (
        <div
          className='px-3'
          key={l.lang}
          onClick={() => {
            setLanguage(l.lang)
          }}
        >
          <a
            href='#'
            className={clsx('d-flex text-uppercase', { active: l.lang === currentLanguage?.lang })}
          >
            <span className='symbol symbol-20px me-2'>
              <img className='rounded-1' src={l.flag} alt='metronic' />
            </span>
            {l.lang}
          </a>
        </div>
      ))}
    </div>
  )
}

export { Languages }
